import type { Abi } from 'viem';
import { erc20Abi, faucetAbi } from '../../shared/abis';
import type { Address, ReserveSnapshot } from '../../shared/types';

/** A contract write for the transaction helper (the shape of TxRequest in data/tx). */
export interface FaucetTx { label: string; address: Address; abi: Abi; functionName: string; args: readonly unknown[] }

/**
 * The transaction that mints one test token to the caller: stock tokens are minted by the market's StockFaucet (the only
 * public minter, one claim per account and cooldown); an open-mint token such as USDG mints itself.
 */
export function faucetRequest(reserve: ReserveSnapshot, faucet: Address | null | undefined, label: string): FaucetTx {
  if (reserve.faucet.kind === 'stock' && faucet) return { label, address: faucet, abi: faucetAbi, functionName: 'claim', args: [reserve.address] };
  return { label, address: reserve.address, abi: erc20Abi, functionName: 'mint', args: [BigInt(reserve.faucet.amount)] };
}
